<template>
  <div id="skills" class="container-sm container">
    <div class="title">
      <h2>Tech Skills</h2>
    </div>
    <div class="skills-grid">
      <div
        class="skill-card"
        v-for="(skill, index) in skills"
        :key="`skill-${index}`"
      >
        <a class="skill-link" :href="skill.wiki">
          <v-card>
            <v-card-title>
              <img :src="skill.icon" alt="" class="icon">
            </v-card-title>
            <v-card-text>
              <p>{{ skill.name }}</p>
            </v-card-text>
          </v-card>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import skills from '../../data/skills.js';

export default {
  name: 'HomeSkills',
  data() {
    return {
      skills: skills
    };
  }
};
</script>

<style scoped>
.container {
  margin-top: 15%;
  width: 70%;
  text-align: center;
}

.title {
  margin-bottom: 5%;
}

.card {
  width: 100px;
  height: 100px;
  margin-left: 20px;
  margin-right: 20px;
}

/* Image styles */
.icon {
  width: 50px;
  height: 50px;
}

.skill-card {
  display: flex;
  justify-content: center;
}

.skill-link {
  display: inline-block;
  color: white;
  text-decoration: none;
}

.skill-link:hover {
  text-decoration: none;
  color: rgb(155, 74, 74);
  transition: 400ms;
}

/* Text styles */
h2 {
  text-align: center;
  color: rgb(155, 74, 74);
  font-weight: bold;
}

.skills-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 30px;
  justify-items: center;
}

@media screen and (max-width: 768px) {
  .container {
    width: 90%;
    margin: 0 auto;
  }

  .skills-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    justify-items: center;
  }
}
</style>
